import { Editor } from '@tinymce/tinymce-react';
import { getMIMEFromFileName } from '@vindr/utils/converter';
import resizeBase64Image from '@vindr/utils/resizeBlobImage';
import { forwardRef, memo, useEffect, useState } from 'react';

interface TextEditor {
  content: string;
  disabled?: boolean;
  height?: number;
  form?: any;
  name?: string;
  resize?: boolean;
}

const TextEditor = forwardRef(
  ({ content, disabled, height = 500, form, name, resize = true }: TextEditor, ref: any) => {
    const [value, setValue] = useState(content ?? '');

    useEffect(() => {
      setValue(content ?? '');
    }, [content]);

    const handleEditorChange = (newValue, editor) => {
      setValue(newValue);

      if (name && form) form.setFieldValue(name, newValue);
    };

    return (
      <article
        className="rounded-[10px] bg-white"
        {...(height && !resize && { style: { height } })}
      >
        <Editor
          ref={ref}
          scriptLoading={{ defer: true }}
          // https://www.tiny.cloud/docs/integrations/react/#procedure
          tinymceScriptSrc={'/tinymce/tinymce.min.js'} // https://www.tiny.cloud/docs/tinymce/6/react-pm-host/
          initialValue={content}
          value={value}
          onEditorChange={handleEditorChange}
          disabled={disabled}
          init={{
            height,
            images_upload_handler: async (blobInfo) => {
              const type = getMIMEFromFileName(blobInfo.filename());
              const url = (await `data:${type};base64,`) + blobInfo.base64();

              return await resizeBase64Image(url, { type });
            },
            plugins: [
              'advlist',
              'autolink',
              'lists',
              'link',
              'image',
              'charmap',
              // 'anchor',
              'searchreplace',
              'visualblocks',
              'code',
              'fullscreen',
              'insertdatetime',
              'media',
              'table',
              'preview',
              'help',
              'wordcount',
            ],
            resize,
            toolbar:
              'undo redo | blocks | ' +
              'bold italic forecolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          }}
        />
      </article>
    );
  }
);

export default memo(TextEditor);
